import { useRef } from 'react';

import type { CanvasRef } from '../../core/components/canvas/Canvas.js';
import { useTimeseriesFilteredData } from '../hooks/useTimeseriesFilteredData.js';
import { TimeseriesGenericCanvasLayout } from './TimeseriesGenericCanvasLayout.js';
import { TimeseriesHighlightedCanvasLayout } from './TimeseriesHighlightedCanvasLayout.js';

export const TimeseriesCanvasLayout = () => {
  const canvasRef = useRef<CanvasRef[]>([]);
  const { dataPerVariant } = useTimeseriesFilteredData();

  const handleOpacityChange = (value: string) => {
    if (canvasRef && canvasRef.current) {
      // The opacity change is done through direct DOM manipulation since canvas elements are not React components and we want to avoid re-renders
      canvasRef.current.forEach((canvas) => {
        canvas.customSetStyle('opacity', value);
      });
    }
  };

  return (
    <>
      <TimeseriesGenericCanvasLayout
        ref={canvasRef}
        dataPerVariant={dataPerVariant}
      />
      <TimeseriesHighlightedCanvasLayout handleOpacity={handleOpacityChange} />
    </>
  );
};

TimeseriesCanvasLayout['displayName'] = 'TimeseriesCanvasLayout';
